// A 0% slice still occupies the pie padding angle, so every empty rating
// is drawn at the same point. MUI only skips a label when the arc is
// narrower than arcLabelMinAngle, and the default of 0 does not hide them
// (0 < 0 is false). Leave those slices unlabeled; the legend still shows the count.
export const evaluationArcLabel = item => (item?.value > 0 ? `${item.value}%` : '')

export const evaluationPieLabelProps = {
    arcLabel: evaluationArcLabel,
    // With paddingAngle 5 and three slices, a 0% arc is only that 5° pad.
    // A 1% arc is about 8.45° (3.45° of value + 5° pad), so this keeps 1%
    // labels while still skipping the empty padding-only slices.
    arcLabelMinAngle: 6,
    arcLabelRadius: '60%'
}
